import type { FunctionComponent } from "react";

import Button from "~/components/buttons/Button/Button";
import CardContent from "~/components/Card/components/CardContent";
import CardHeader from "~/components/Card/components/CardHeader";
import CardTitle from "~/components/Card/components/CardTitle";
import CardWrapper from "~/components/Card/components/CardWrapper";
import type { Invoice } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import { formatSmartDateRange } from "~/utils/dateAndTimeUtils.ts";

type Props = { invoiceData: Invoice, onUpdateClick?: () => void };

const InvoiceDeliveryPeriodSection: FunctionComponent<Props> = ({ invoiceData, onUpdateClick }) => {
	return <CardWrapper hasTitle={true}
						padding="none">
		<CardHeader hasTitle={true}>
			<CardTitle>Leistungszeitraum</CardTitle>
			{onUpdateClick && <Button size="auto"
									  theme="plain"
									  className="px-2 py-1 text-xs"
									  onClick={onUpdateClick}>Bearbeiten</Button>}
		</CardHeader>
		<CardContent padding="none">
			<div className="gap-x-4 gap-y-2 px-4 py-3 text-sm">
				{formatSmartDateRange(new Date(invoiceData.deliveryStartDate), new Date(invoiceData.deliveryEndDate), {
					month: "MMMM",
					year: " yyyy",
				})}
			</div>
		</CardContent>
	</CardWrapper>;
};

export default InvoiceDeliveryPeriodSection;